import { Component, OnInit, Input } from "@angular/core";
import { UntypedFormArray, UntypedFormControl, UntypedFormGroup, Validators } from "@angular/forms";
import { MatLegacyDialog as MatDialog } from "@angular/material/legacy-dialog";
import { TranslateService } from "@ngx-translate/core";
import { Observable } from "rxjs";

import { activityInput } from "../models";
import { CustomModalPopupComponent } from "../custom-modal-popup/custom-modal-popup.component";
import { InputValidationService } from "../service/input-validation.service";
import { GSFReport } from "../GSF-report.service";
import { constants } from "../constants/constants";
import { CommonDependencyService } from "../service/common-dependency.service";
import { ActivatedRoute } from "@angular/router";

@Component({
  selector: "app-dropdown",
  templateUrl: "./dropdown.component.html",
  styleUrls: ["./dropdown.component.css"],
})
export class DropdownComponent implements OnInit {
  @Input()
  activity: activityInput;
  @Input()
  activityControl: UntypedFormControl;
  @Input()
  activityInputList: Array<any>;
  @Input()
  questionForm: UntypedFormGroup;

  @Input()
  pillarName: string;

  @Input()
  qusId: string;

  toolTipText: string;
  selectedlang: string;
  private setFromIndex: number;

  constructor(
    public report: GSFReport,
    private readonly translate: TranslateService,
    private readonly inputValService: InputValidationService,
    private readonly dialog: MatDialog,
    private readonly commonService: CommonDependencyService,
    public route: ActivatedRoute
  ) {
    this.translate.setDefaultLang(constants.LANGUAGE);
    this.selectedlang = constants.LANGUAGE;
  }

  ngOnInit() {
    this.activityControl.valueChanges.subscribe((value) => {
      this.activity.ans = value;
    });

    if (this.activity.values && this.activity.values.length < 1) {
      this.activityControl.disable();
    }
    this.initializeRequiredError();
    this.enableDisableDependControls(this.activity.ans);
    this.setRequiredError();
    if(!this.activity.ans){
      if(this.activity.defaultDisable === true) {
        this.activityControl.disable();
      }
    }
  }

  private selectOtherDropDown(selectedValue) {
    if (this.activity.defaultSelection && this.activity.defaultSelection.length > 0) {
      this.activity.defaultSelection.forEach(ds => {
        const control = this.questionForm.get("inputList")["controls"][ds.dependencyIndex]
        if (control) {
          if (ds.selectForValue === selectedValue) {
            control.setValue(ds.defaultValue)
          } else {
            control.setValue(null)
          }
        }
      })
    }
  }

  private enableDisableDependControls(selectedValue) {
    if (this.activity["dependancy"].flag) {
      const deptId = this.activity["dependancy"]["depId"];
      this.populateDropDown(deptId, selectedValue);
    }
    if (
      this.activity["hasSecondDep"] &&
      this.activity["hasSecondDep"]["flag"]
    ) {
      const deptId = this.activity["hasSecondDep"]["depId"];
      this.populateDropDown(deptId, selectedValue);
    }
    if (this.activity["dependancy"].external && selectedValue) {
      const deptId = this.activity["dependancy"]["depId"];
      this.populateDropDownExternal(deptId, selectedValue);
    }

    if (this.activity["dependancy"].call) {
      const deptId = this.activity["dependancy"]["depId"];
      this.populateFromExternalCommon(deptId, this.activity);
    }
  }

  getTooltipText(activityConfig) {
    if (activityConfig != null) {
      if (this.activityControl.value) {
     const toolTipText=  this.activity["values"].find((per) =>per.value === activityConfig.ans);
        return toolTipText?toolTipText.name : null;
      }
      else {
        return activityConfig.hint;
      }
    } else{
      return "";
    }
  }

  getTooltip(option) {
    if(option){
      return option.replaceAll(';', ' ');
    }
    else {
      return option
    }
  }

  private updateFirstDependancy(selectedValue) {
    const deptId = this.activity.dependancy.depId;
    if (
      this.activity.exceptional_case &&
      this.activity.parent_input_control_id
    ) {
      const parentCtlValue = this.getInputValueById(
        this.activity.parent_input_control_id
      );

      parentCtlValue === this.activity.exceptional_case
        ? this.populateDependedDropDowns(deptId, this.activity.exceptional_case)
        : this.populateDependedDropDowns(deptId, selectedValue);
    } else {
      this.populateDependedDropDowns(deptId, selectedValue);
    }
  }

  populateDependvalues(selectedValue: string): void {

    this.setDependentRequiredError(selectedValue);
    this.setRequiredError();
    if (this.activity.dependancy.flag) {
      this.updateFirstDependancy(selectedValue);
    }
    if (this.activity.hasSecondDep && this.activity.hasSecondDep.flag) {
      const deptId = this.activity.hasSecondDep.depId;
      this.populateDependedDropDowns(deptId, selectedValue);
    }

    if (this.activity["dependancy"].external && selectedValue) {
      const deptId = this.activity["dependancy"]["depId"];
      this.populateDropDownExternal(deptId, selectedValue);
    }
    this.showWarningDates(selectedValue);
    this.allDependEntries();
    this.selectOtherDropDown(selectedValue);
  }

  private showWarningDates(selectedValue){
    if (
      this.activity.showDateWarning15 &&
      selectedValue === constants.SELECTEDVALUE_2015
    ) {
      this.openDateWarningDialog(
        this.activity.dateWarningMessage2015
          ? this.activity.dateWarningMessage2015
          : ""
      );
    }
    if (
      this.activity.showDateWarning16 &&
      selectedValue === constants.SELECTEDVALUE_C
    ) {
      this.openDateWarningDialog(
        this.activity.dateWarningMessage2016
          ? this.activity.dateWarningMessage2016
          : ""
      );
    }
    if (
      this.activity.showDateWarning17 &&
      selectedValue === constants.SELECTEDVALUE_2017
    ) {
      this.openDateWarningDialog(
        this.activity.dateWarningMessage2017
          ? this.activity.dateWarningMessage2017
          : ""
      );
    }
    if (
      this.activity.showDateWarning18 &&
      selectedValue === constants.SELECTEDVALUE_2018
    ) {
      this.openDateWarningDialog(
        this.activity.dateWarningMessage2018
          ? this.activity.dateWarningMessage2018
          : ""
      );
    }
  }

  private clearDependedValues(depId: string): void {
    this.activityInputList.forEach((obj) => {
      if (obj.inputControlID === depId) {
        obj.ans = null;
        this.disableDependedInputs(depId);
      }
    });
  }

  // private disableDependedInputs(deptId: string): void {
  //   const inpCtl = this.inputValService.inputFormCtlAndObj[deptId]
  //     .inputControl as FormControl;
  //   inpCtl.disable();
  // }

  disableDependedInputs(deptId) {
    this.activityInputList.forEach((inp, index) => {
      if (inp.inputControlID === deptId) {
        const inpCtls = this.questionForm.get("inputList") as UntypedFormArray;
        const inpCtl = inpCtls.controls[index] as UntypedFormControl;
        inpCtl.setValue(null);
        inpCtl.disable();
      }
    });
  }

  private clearFormControl(deptId: string): void {
    const inpCtl = this.inputValService.inputFormCtlAndObj[deptId]
      .inputControl as UntypedFormControl;
    inpCtl.setValue(null);
  }

  private enableDependedInputs(deptId: string): void {
    const inpCtl = this.inputValService.inputFormCtlAndObj[deptId]
      .inputControl as UntypedFormControl;
    inpCtl.enable();
  }

  private getInputValueById(inputId: string): string {
    let value = null;
    this.activityInputList.forEach((obj) => {
      if (obj.inputControlID === inputId) {
        value = obj.ans;
      }
    });
    return value;
  }

  private initializeRequiredError(): void {
    if (this.activity.dependencyIndex) {
      const requiredDependencyIndex = this.activity.dependencyIndex;
      const value = this.questionForm.get("inputList")["controls"][
        requiredDependencyIndex
      ].value;
      if (value) {
        this.activityControl.clearValidators();
        this.activityControl.updateValueAndValidity();
      } else {
        this.activityControl.setValidators([Validators.required]);
        this.activityControl.updateValueAndValidity();
      }
    }
  }

  private allDependEntries() {
    this.activityInputList.forEach(al => {
      if(al["dependancy"] && al["dependancy"].call)
      {
        const deptIds = al["dependancy"]["depId"];
        if(deptIds && deptIds.some(d => d === this.activity.inputControlID)) {
          this.disableDependedInputs(al.inputControlID)
          this.populateFromExternalCommon(deptIds, al);
        }
      }
    })
  }

  private openDateWarningDialog(label: string): Observable<boolean> {
    const dialogRef = this.dialog.open(CustomModalPopupComponent, {
      data: { label },
    });
    return dialogRef.afterClosed();
  }

  private populateDependedDropDowns(deptId: string, selectedValue: string) {
    this.activityInputList.forEach((obj) => {
      if (obj.inputControlID === deptId) {
        obj.ans = null;
        this.clearFormControl(deptId);
        if (obj[selectedValue]) {
          this.enableDependedInputs(deptId);
        } else {
          this.disableDependedInputs(deptId);
        }
        obj["values"] = obj[selectedValue];
        if (obj["dependancy"].flag) {
          this.clearDependedValues(obj["dependancy"]["depId"]);
        }

        if (obj["hasSecondDep"] && obj["hasSecondDep"].flag) {
          this.clearDependedValues(obj["hasSecondDep"]["depId"]);
        }
      }
    });
  }

  private setRequiredError(): void {
    let oldValue = "";
    let oldIndex = null;
    this.activityInputList.forEach((activity, index) => { //nosonar
      if (activity["requiredFields"] && activity["requiredFields"].length > 0) {
        activity["requiredFields"].forEach(rf => {
          const requiredDependencyIndex = rf.dependencyIndex;
          const requiredForValue = rf.requiredForValue;
          const control = this.questionForm.get("inputList")["controls"][requiredDependencyIndex]
          if (control) {
            const depActivity = this.activityInputList[requiredDependencyIndex];
            if (activity.ans === requiredForValue || !requiredForValue) {
              if (rf.controlVisibility === true) {
                depActivity["controlVisibility"] = "show";
              }
              control.markAllAsTouched();
              if(!rf.requiredException) {
              control.setValidators([Validators.required]);
              }
              this.setFromIndex = index;
              if (rf.controlState === true) {
                control.enable();
                if(requiredDependencyIndex === oldIndex) {
                  control.setValue(oldValue)
                }
              }
            } else {
              if (rf.controlState === true) {
                if (control.value && oldValue !== control.value) {
                  oldValue = control.value;
                  oldIndex = requiredDependencyIndex;
                }
                control.setValue(null);
                control.disable();
              }
              if (rf.controlVisibility === true) {
                depActivity["controlVisibility"] = "hidden";
              }
              if (this.setFromIndex === index) {
                control.clearValidators();
              }
            }
            control.updateValueAndValidity();
          }
        })
      }
    });
  }

  private setDependentRequiredError(selectedValue: string): void {
    if (
      this.activity.requiredDependencyId &&
      this.activity.requiredDependencyIndex
    ) {
      const requiredDependencyIndex = this.activity.requiredDependencyIndex;
      if (selectedValue) {
        this.questionForm
          .get("inputList")
          ["controls"][requiredDependencyIndex].clearValidators();
        this.questionForm
          .get("inputList")
          ["controls"][requiredDependencyIndex].updateValueAndValidity();
      } else {
        this.questionForm
          .get("inputList")
          ["controls"][requiredDependencyIndex].setValidators([
            Validators.required,
          ]);
        this.questionForm
          .get("inputList")
          ["controls"][requiredDependencyIndex].updateValueAndValidity();
      }
    }
  }

  populateDropDown(deptId, selectedValue) {
    this.activityInputList.forEach((obj) => {
      if (obj.inputControlID === deptId) {
        if (obj[selectedValue]) {
          this.enableDependedInputs(deptId);
        } else {
          this.disableDependedInputs(deptId);
        }
      }
    });
  }

  populateDropDownExternal(deptId, selectedValue) {
    const language = this.route.snapshot.params.lang;
    this.commonService
      .getCounty(selectedValue, language)
      .subscribe((co: any) => {
        this.activityInputList.forEach((obj) => {
          if (obj.inputControlID === deptId) {
            if (co) {
              this.enableDependedInputs(deptId);
            } else {
              this.disableDependedInputs(deptId);
            }
            if (co && co.length > 0) {
              const na = this.translate.instant("Select");
              co.unshift({ name: na, value: null });
            }
            obj["values"] = co;
            this.clearDependancy(obj);
          }
        });
      });
  }

  private clearDependancy(obj) {
    if (obj["dependancy"].flag) {
      this.clearDependedValues(obj["dependancy"]["depId"]);
    }

    if (obj["hasSecondDep"] && obj["hasSecondDep"].flag) {
      this.clearDependedValues(obj["hasSecondDep"]["depId"]);
    }
  }

  populateFromExternalCommon(deptIds, activity) {
    var { canCall, depValues } = this.getDependentValues(deptIds, activity);
    if (canCall) {
      const language = sessionStorage.getItem('language');
      this.commonService
        .getDependValues(this.pillarName, this.qusId, depValues, activity.inputControlID, language)
        .subscribe((co: any) => {
          if (co) {
            this.enableDependedInputs(activity.inputControlID);
            activity["values"] = co;
          } else {
            this.disableDependedInputs(activity.inputControlID)
          }
        });
    } else {
      this.disableDependedInputs(activity.inputControlID)
    }
  }

  private getDependentValues(deptIds: any, activity: any) {
    const depValues = [];
    let canCall = true;
    if (deptIds && deptIds.length > 0) {
      deptIds.forEach(di => {
        const actInput = this.activityInputList.find(ac => ac.inputControlID === di);
        if (actInput) {
          if (actInput.ans || (activity.inputControlID === di)) {
            depValues.push(actInput.ans);
          } else {
            canCall = false;
          }
        }
      });
    }
    return { canCall, depValues };
  }
}
